import { render } from "./TableData4Show.vue?vue&type=template&id=87e678ac&scoped=true"
import script from "./TableData4Show.vue?vue&type=script&lang=js"
export * from "./TableData4Show.vue?vue&type=script&lang=js"

import "./TableData4Show.vue?vue&type=style&index=0&id=87e678ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87e678ac"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData4Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87e678ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87e678ac', __exports__)) {
    api.reload('87e678ac', __exports__)
  }
  
  module.hot.accept("./TableData4Show.vue?vue&type=template&id=87e678ac&scoped=true", () => {
    api.rerender('87e678ac', render)
  })

}


export default __exports__